export default __webpack_public_path__ + "static/media/playButton.e446ff5d.jpg";